import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import {
  LayoutDashboard, Users, CreditCard, Tag, ArrowLeft, LogOut, Shield,
  BarChart3, DollarSign, Sliders, Package, Megaphone
} from "lucide-react";

const ADMIN_NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/admin/users", icon: Users, label: "Users" },
  { to: "/admin/revenue", icon: CreditCard, label: "Revenue" },
  { to: "/admin/subscriptions", icon: Package, label: "Subscriptions" },
  { to: "/admin/analytics", icon: BarChart3, label: "Analytics" },
  { to: "/admin/costs", icon: DollarSign, label: "Costs" },
  { to: "/admin/promos", icon: Tag, label: "Promo Codes" },
  { to: "/admin/features", icon: Sliders, label: "Features" },
  { to: "/admin/announcements", icon: Megaphone, label: "Announcements" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user?.role !== "admin") {
    return (
      <div className="auth-loading">
        <Shield size={32} />
        <span>Admin access required</span>
        <button className="btn-secondary" onClick={() => navigate("/app")}>Back to App</button>
      </div>
    );
  }

  return (
    <div className="admin-layout" data-testid="admin-layout">
      <aside className="admin-sidebar" data-testid="admin-sidebar">
        <div className="admin-sidebar-top">
          <div className="admin-brand">
            <Shield size={16} />
            <span>Admin Panel</span>
          </div>
        </div>
        <nav className="admin-nav">
          {ADMIN_NAV.map(({ to, icon: Icon, label, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => `dash-nav-item ${isActive ? "active" : ""}`}
              data-testid={`admin-nav-${label.toLowerCase().replace(" ", "-")}`}
            >
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-bottom">
          <button className="dash-nav-item" onClick={() => navigate("/app")} data-testid="admin-back-to-app">
            <ArrowLeft size={18} /><span>Back to App</span>
          </button>
          <button className="dash-nav-item" onClick={async () => { await logout(); window.location.href = "/"; }}
            data-testid="admin-logout">
            <LogOut size={18} /><span>Sign Out</span>
          </button>
        </div>
      </aside>
      <main className="admin-main" data-testid="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
